import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const StepperStatusIcon = ({ active, completed }) => {
  const getIcon = () => {
    if (completed) {
      return {
        icon: ['fal', 'check-circle'],
        color: 'success',
      };
    }

    if (active) {
      return {
        icon: ['fal', 'dot-circle'],
        color: 'action',
      };
    }

    return {
      icon: ['fal', 'dot-circle'],
      color: 'disabled',
    };
  };

  const finalIcon = getIcon();

  return <Icon icon={finalIcon.icon} color={finalIcon.color} />;
};

StepperStatusIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
};

StepperStatusIcon.defaultProps = {
  active: false,
  completed: false,
};

export default StepperStatusIcon;
